// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const DownIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Down",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.7 23.5c.11-.06.21-.12.3-.19s.18-.11.18-.11h.08l12.19-11.64c.35-.32.56-.78.56-1.29a1.746 1.746 0 0 0-2.94-1.28S16.06 19.48 16.06 19.48L5.03 8.98A1.746 1.746 0 0 0 2 10.17c0 .53.24 1.01.61 1.33S14.8 23.15 14.8 23.15h.08l.18.11c.09.07.19.13.29.18.09.03.2.06.31.07q.15.045.33.06c.12 0 .24-.03.34-.06h-.01.07c.1 0 .2 0 .29-.03Z"
    })
  });
};